import api from "../api/api";

export const AboutService = {
  /**
   * "Haqqında" səhifəsinin məzmunu (admin paneldən idarə olunur).
   * Mətn sahələri {az,en,ru} obyektidir — dili front seçir.
   * Səhifə admin tərəfindən gizlədilibsə backend 404 qaytarır.
   */
  get: async () => {
    const response = await api.get("about");
    return response.data; // { about: {...} }
  },
};
